import { render, staticRenderFns } from "./DetailsInTable.html?vue&type=template&id=6ed7b330&scoped=true&"
import script from "./DetailsInTable.js?vue&type=script&lang=js&"
export * from "./DetailsInTable.js?vue&type=script&lang=js&"
import style0 from "./DetailsInTable.scss?vue&type=style&index=0&id=6ed7b330&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7b330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
